module.exports = __webpack_public_path__ + "static/media/Angular.f74ebee0.png";